<template>
  <div class="guide">
    <div class="guide__logo" :class="`text-${align}`">
      <slot name="logo">
        <LogoImage :width="`${size}px`"></LogoImage>
      </slot>
    </div>

    <div class="guide__contents">
      <slot name="contents"></slot>
    </div>

    <div class="guide__activator" :class="{ fluid: fluid }">
      <div class="activator-inner">
        <slot name="activator"></slot>
      </div>
    </div>
    <ChannelPluginStyle :stylePack="{ 'nudge-bottom': 'bottom: 85px !important' }" />
  </div>
</template>

<script>
export default {
  components: {
    ChannelPluginStyle: () => import('@/components/channel/ChannelPluginStyle.vue'),
  },
  props: {
    size: {
      type: Number,
      default: 140,
    },
    align: {
      type: String,
      default: 'center',
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    hideChannel: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const className = this.hideChannel ? 'hide-channel' : 'ch-up'
    document.getElementsByTagName('body')[0].classList.add(className)
  },
  destroyed() {
    const className = this.hideChannel ? 'hide-channel' : 'ch-up'
    document.getElementsByTagName('body')[0].classList.remove(className)
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.guide {
  position: relative;
  min-height: 100vh;
  background-color: white;

  padding: 20px 0;

  &__contents {
    img {
      width: 100%;
      max-height: 220px;
      object-fit: contain;
    }
  }

  &__activator {
    position: fixed;
    left: 0;
    bottom: 20px;

    display: flex;
    justify-content: center;

    width: 100%;

    z-index: 5;

    > div.activator-inner {
      max-width: $standard-max-width;
      width: 100%;

      padding-left: 8px;
      padding-right: 8px;
    }

    &.fluid {
      > div.activator-inner {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
}
</style>
